<template>
    <div>
        <div class="flex justify-end my-2">
            <!-- <el-button plain size="small" @click="exportToExcel" v-if="this.userInfo.userType != '2'">Export in Excel
                File</el-button> -->
            <div>
                <el-button type="primary" size="small" @click="saveTransaction"
                    v-if="this.userInfo.userType != '2'">Save</el-button>
                <el-button size="small" @click="handleCloseClick">Close</el-button>
            </div>
        </div>

        <div class="ship-detail p-4"
            :style="{ backgroundColor: '#ffffff', borderRadius: '10px', height: isMobileOrTablet ? 'auto' : 'calc(108vh - 210px)', overflowY: 'auto' }">
            <h2 class="text-lg font-semibold mb-4">Tank Transactions - {{ tankName }}</h2>
            <h3 class="font-medium my-4 ">Balance Information</h3>
            <el-form ref="terminalForm" :model="balanceForm" :rules="rules" size="small"
                :label-width="isMobileOrTablet ? null : '160px'" :label-position="isMobileOrTablet ? 'top' : 'left'"
                :disabled="this.userInfo.userType == '2'"
                :style="{ display: 'grid', gridTemplateColumns: isMobileScreen ? '1fr' : isMobileOrTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', columnGap: '24px', rowGap: '12px' }">

                <el-form-item label="Tank:">
                    <el-input v-model="tankName" size="mini" :disabled="true" />
                </el-form-item>

                <el-form-item label="Tank Farm:">
                    <el-input v-model="tankFarm" size="mini" :disabled="true" />
                </el-form-item>

                <el-form-item label="Product:">
                    <el-select v-model="balanceForm.product" placeholder="Select product" size="mini" clearable>
                        <el-option v-for="item in productOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Metric Ton:">
                    <el-input v-model="balanceForm.metricTon" size="mini" />
                </el-form-item>

                <el-form-item label="Temp.(°C):">
                    <el-input v-model="balanceForm.temp" size="mini" />
                </el-form-item>

                <el-form-item label="GOV (m³):">
                    <el-input v-model="balanceForm.gov" size="mini" />
                </el-form-item>

                <el-form-item label="US BBLs@60°F:">
                    <el-input v-model="balanceForm.bbl" size="mini" />
                </el-form-item>

                <el-form-item label="GSV (m³):">
                    <el-input v-model="balanceForm.gsv" size="mini" />
                </el-form-item>

                <el-form-item label="Density@15°C (KG/L):">
                    <el-input v-model="balanceForm.density" size="mini" />
                </el-form-item>

                <el-form-item label="Customer:">
                    <el-select v-model="selectedCustomer" multiple filterable clearable size="mini" :disabled="true" />
                </el-form-item>
            </el-form>
            <!-- <div class="flex justify-between items-center mb-4">
                <h3 class="font-medium">Tank Transaction Record</h3>
                <div class="flex gap-2">
                    <el-date-picker v-model="dateRange" type="datetimerange" range-separator="-" size="small"
                        value-format="yyyy-MM-dd HH:mm:ss" />
                    <el-input v-model="searchKeyword" placeholder="Search" size="small" style="width: 200px;" />
                    <el-button type="primary" size="small" @click="openAddTransactionModal"
                        v-if="this.userInfo.userType != '2'">Add a Transaction
                        Record</el-button>
                </div>
            </div> -->

            <!-- <el-table :data="transactionList" border table-layout="auto" min-height="270px" max-height="580px"
                style="width: 100%;">
                <el-table-column label="Job No." prop="jobNo" width="120" />
                <el-table-column label="Operation Time" prop="operationTime" min-width="180" />
                <el-table-column label="Trans. Product" prop="transProduct" width="150" />
                <el-table-column label="Final Product" prop="finalProduct" width="150" />
                <el-table-column label="Customer" prop="customer" width="150" />
                <el-table-column label="Operation Code" prop="operationCode" width="140" />
                <el-table-column label="Vessel/Operation" prop="vesselOperation" width="160" />
                <el-table-column label="Temp." prop="temp" width="100" align="center" />
                <el-table-column label="Density@15°C" prop="density" width="130" align="center" />
                <el-table-column label="Trans GOV" prop="transGov" width="120" align="right" />
                <el-table-column label="Trans GSV" prop="transGsv" width="120" align="right" />
                <el-table-column label="Trans MT" prop="transMt" width="120" align="right" />
                <el-table-column label="Trans BBL" prop="transBbl" width="120" align="right" />
                <el-table-column label="Bal GOV" prop="balGov" width="120" align="right" />
                <el-table-column label="Bal GSV" prop="balGsv" width="120" align="right" />
                <el-table-column label="Bal MT" prop="balMt" width="120" align="right" />
                <el-table-column label="Bal BBL" prop="balBbl" width="120" align="right" />
                <el-table-column label="Action By" prop="actionBy" width="120" align="right" />
                <el-table-column label="Action Date" prop="actionDate" min-width="180" align="left" />

                <el-table-column label="Actions" align="center" width="120" fixed="right"
                    v-if="this.userInfo.userType != '2'">
                    <template #default="{ row }">
                        <el-button type="primary" icon="el-icon-edit" size="mini" circle
                            @click="editTransaction(row)" />
                        <el-button type="danger" icon="el-icon-delete" size="mini" circle
                            @click="deleteTransaction(row)" />
                    </template>
</el-table-column>
</el-table>

<div class="barging-pagination">
    <pagination :total="total" :page.sync="transactionListParams.pageNum" :limit.sync="transactionListParams.pageSize"
        @pagination="getTransactionList()"></pagination>
</div> -->
            <div :class="isMobileOrTablet ? 'flex flex-col gap-2 mb-4' : 'flex justify-between items-center mb-4'">
                <h3 class="font-medium">Audit Trail</h3>
                <el-date-picker v-model="dateRange" type="datetimerange" range-separator="-" size="small"
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="Start Date" end-placeholder="End Date"
                    :style="isMobileOrTablet ? { width: '100%' } : {}"></el-date-picker>
            </div>
            <div :style="isMobileOrTablet ? { overflowX: 'auto' } : {}">
            <el-table :data="historyList" :header-cell-style="{
                height: '55px',
                background: '#fff',
                'border-bottom': '2px solid #D6D9E1',
            }" :cell-style="getCellStyle" table-layout="auto">
                <el-table-column prop="method" label="Update Method" width="130">
                    <template #default="scope">
                        {{ getMethodLabel(scope.row.method) }}
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="Update Time" width="160" />
                <el-table-column prop="updateByName" label="Updated By" width="120" />
                <el-table-column prop="product" label="Product" width="120" />
                <el-table-column prop="metricTon" label="Metric Ton" width="120" />
                <el-table-column prop="gov" label="GOV (m³)" width="100" />
                <el-table-column prop="gsv" label="GSV (m³)" width="100" />
                <el-table-column prop="bbl" label="US BBLs@60°F" width="100" />
                <el-table-column prop="density" label="Density@15°C (KG/L)" width="120" />
                <el-table-column prop="temp" label="Temp (°C)" width="100" />

            </el-table>
            </div>

            <div class="barging-pagination">
                <pagination :total="historyTotal" :page.sync="pageParams.pageNum" :limit.sync="pageParams.pageSize"
                    @pagination="getHistoryList()"></pagination>
            </div>
        </div>
        <!-- <el-dialog :title="isEditing ? 'Edit Transaction' : 'Add New Transaction'" :visible.sync="addModalVisible"
            width="50%" :close-on-click-modal="false">
            <div style="max-height: 50vh; overflow-y: auto; padding-right: 8px;">
                <el-form :model="newTransaction" label-width="160px" size="small">
                    <el-form-item label="Job No."><el-input v-model="newTransaction.jobNo" /></el-form-item>
                    <el-form-item label="Operation Time">
                        <el-date-picker v-model="newTransaction.operationTime" type="datetime" />
                    </el-form-item>
                    <el-form-item label="Trans Product"><el-input
                            v-model="newTransaction.transProduct" /></el-form-item>
                    <el-form-item label="Final Product"><el-input
                            v-model="newTransaction.finalProduct" /></el-form-item>
                    <el-form-item label="Customer"><el-input v-model="newTransaction.customer" /></el-form-item>
                    <el-form-item label="Operation Code"><el-input
                            v-model="newTransaction.operationCode" /></el-form-item>
                    <el-form-item label="Vessel/Operation"><el-input
                            v-model="newTransaction.vesselOperation" /></el-form-item>
                    <el-form-item label="Temp (°C)"><el-input v-model="newTransaction.temp" /></el-form-item>
                    <el-form-item label="Density@15°C"><el-input v-model="newTransaction.density" /></el-form-item>
                    <el-form-item label="Trans GOV"><el-input v-model="newTransaction.transGov" /></el-form-item>
                    <el-form-item label="Trans GSV"><el-input v-model="newTransaction.transGsv" /></el-form-item>
                    <el-form-item label="Trans MT"><el-input v-model="newTransaction.transMt" /></el-form-item>
                    <el-form-item label="Trans BBL"><el-input v-model="newTransaction.transBbl" /></el-form-item>
                    <el-form-item label="Balance GOV"><el-input v-model="newTransaction.balGov" /></el-form-item>
                    <el-form-item label="Balance GSV"><el-input v-model="newTransaction.balGsv" /></el-form-item>
                    <el-form-item label="Balance MT"><el-input v-model="newTransaction.balMt" /></el-form-item>
                    <el-form-item label="Balance BBL"><el-input v-model="newTransaction.balBbl" /></el-form-item>
                </el-form>
            </div>

            <template #footer>
                <el-button @click="addModalVisible = false">Cancel</el-button>
                <el-button type="primary" @click="saveTransactionRecord">Save</el-button>
            </template>
</el-dialog> -->
    </div>
</template>

<script>
import { getProductList } from '@/services';
import { getTankBookDetail, getTransactionRecord, createNewTransaction, exportExcel, createNewTransactionRecord, modifyTransactionRecord, deleteTransactionRecord, modifyTransaction, exportTransactionExcel, getTankBookStockHistory } from '@/services/form';
import dayjs from 'dayjs';
import { method } from 'lodash';
import { del } from 'vue';
import { mapState } from 'vuex';

export default {
    name: "TankTransaction",
    data() {
        return {
            isEditing: false,
            tankName: this.$route.query.tank || "",
            tankFarm: this.$route.query.tankFarm || "",
            selectedCustomer: this.$route.query.customer || [],
            balanceForm: {
                tankId: this.$route.query.tankId || "",
                product: "",
                metricTon: "",
                temp: "",
                gov: "",
                gsv: "",
                bbl: "",
                density: "",
            },
            pageParams: {
                pageNum: 1,
                pageSize: 10,
            },
            timelineloading: true,
            loading: false,
            preScrollTop: 0,
            originalBalanceForm: {},
            methodOptions: [
                { label: "Create", value: 1 },
                { label: "Modify", value: 2 },
                { label: "Upload", value: 3 },
            ],
            productOptions: [
            ],
            transactionList: [],
            dateRange: [],
            searchKeyword: "",
            addModalVisible: false,
            newTransaction: {
                id: "",
                transactionId: "",
                jobNo: "",
                operationTime: "",
                transProduct: "",
                finalProduct: "",
                customer: "",
                operationCode: "",
                vesselOperation: "",
                temp: "",
                density: "",
                transGov: "",
                transGsv: "",
                transMt: "",
                transBbl: "",
                balGov: "",
                balGsv: "",
                balMt: "",
                balBbl: "",
                actionBy: "",
                actionDate: ""
            },
            editingTransactionId: null,
            transactionListParams: {
                pageNum: 1,
                pageSize: 10,
                startDate: "",
                endDate: "",
                searchValue: "",
            },
            total: 0,
            historyList: [],
            tankId: null,
            noLog: false,
            historyTotal: 0,
        };
    },
    created() {
        this.getDetail();
        this.getProductList();
    },
    watch: {
        dateRange() {
            this.transactionListParams.pageNum = 1;
            this.getHistoryList();
        },
        searchKeyword() {
            this.transactionListParams.pageNum = 1;
            this.getHistoryList();
        }
    },
    computed: {
        ...mapState(["userInfo", "screenType"]),
        isMobileScreen() {
            return this.screenType?.isMobileScreen ?? false;
        },
        isMobileOrTablet() {
            return this.screenType?.isMobileOrTabletScreen ?? false;
        },
    },
    methods: {
        getProductList() {
            getProductList().then((res) => {
                this.productOptions = res.data.map(item => ({
                    label: item.productName,
                    value: item.productName
                }));
            });
        },
        openAddTransactionModal() {
            this.newTransaction = {
                id: "",
                transactionId: this.$route.query.id || "",
                jobNo: "",
                operationTime: "",
                transProduct: "",
                finalProduct: "",
                customer: "",
                operationCode: "",
                vesselOperation: "",
                temp: "",
                density: "",
                transGov: "",
                transGsv: "",
                transMt: "",
                transBbl: "",
                balGov: "",
                balGsv: "",
                balMt: "",
                balBbl: "",
                actionBy: "",
                actionDate: ""
            };
            this.isEditing = false;
            this.addModalVisible = true;
        },

        editTransaction(record) {
            this.newTransaction = { ...record };
            this.isEditing = true;
            this.addModalVisible = true;
            this.editingTransactionId = record.id;
        },

        getMethodLabel(value) {
            const method = this.methodOptions.find(m => m.value === value);
            return method ? method.label : '';
        },

        async deleteTransaction(record) {
            this.$confirm(
                `Are you sure you want to delete transaction ${record.jobNo}?`,
                "Confirm Deletion",
                { type: "warning" }
            ).then(async () => {
                await deleteTransactionRecord(record.id);
                this.$message.success("Transaction deleted successfully!");
                this.getDetail();
            }).catch(() => {
                this.$message.info("Deletion canceled");
            });
        },


        async saveTransactionRecord() {
            try {
                this.newTransaction.actionDate = dayjs(new Date().toISOString()).format("YYYY-MM-DD HH:mm:ss");
                this.newTransaction.operationTime = this.newTransaction.operationTime ? dayjs(this.newTransaction.operationTime).format("YYYY-MM-DD HH:mm:ss") : "";
                this.newTransaction.actionBy = this.userInfo.userName || "";

                if (JSON.stringify(this.balanceForm) !== JSON.stringify(this.originalBalanceForm)) {
                    let res;
                    if (this.$route.query.id) {
                        res = await modifyTransaction(this.$route.query.id, this.balanceForm);
                    } else {
                        res = await createNewTransaction(this.balanceForm);
                    }

                    if (res.code === 200) {
                        this.$message.success(
                            this.$route.query.id ? "Transaction updated successfully!" : "Transaction created successfully!"
                        );
                        if (!this.$route.query.id) {
                            this.newTransaction.transactionId = res.data;
                        } else {
                            this.newTransaction.transactionId = this.$route.query.id;
                        }
                    } else {
                        this.$message.error(res.message || "Failed to save transaction");
                        return;
                    }
                }

                if (this.isEditing) {
                    delete this.newTransaction.transactionId;
                    delete this.newTransaction.updateBy;
                    delete this.newTransaction.updateTime;
                    delete this.newTransaction.createBy;
                    delete this.newTransaction.createTime;
                    delete this.newTransaction.remark;
                    delete this.newTransaction.id;
                    delete this.newTransaction.isDeleted;
                    await modifyTransactionRecord(
                        this.editingTransactionId,
                        this.newTransaction
                    );
                    this.$message.success("Transaction updated successfully!");
                    this.editingTransactionId = null;

                    const index = this.transactionList.findIndex(
                        (t) => t.transactionId === this.newTransaction.transactionId
                    );
                    if (index !== -1)
                        this.$set(this.transactionList, index, { ...this.newTransaction });
                } else {
                    delete this.newTransaction.id;
                    await createNewTransactionRecord(this.newTransaction);
                    this.$message.success("Transaction created successfully!");
                }

                this.addModalVisible = false;
                if (!this.$route.query.id) {
                    this.$router.push({
                        path: "/tankBookStock/index",
                        query: {
                            id: this.newTransaction.transactionId,
                            pageStatus: 1,
                        },
                    });
                    sessionStorage.setItem("pageStatus", 1);

                    this.$nextTick(() => {
                        this.getDetail();
                    });
                } else {
                    this.getDetail();
                }
            } catch (error) {
                console.error(error);
                this.$message.error("Failed to save transaction");
            }
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },

        async getDetail() {
            try {
                if (this.$route.query.id) {
                    const res = await getTankBookDetail(this.$route.query.id);
                    if (res?.code === 200 && res.data) {
                        const item = res.data;
                        this.balanceForm = {
                            product: item.product || "",
                            metricTon: item.metricTon || "",
                            temp: item.temp || "",
                            gov: item.gov || "",
                            gsv: item.gsv || "",
                            bbl: item.bbl || "",
                            density: item.density || "",
                        };

                        this.originalBalanceForm = { ...this.balanceForm };

                        this.selectedCustomerIds = (item.customers || []).map(c => c.companyId);
                        this.tankName = item.tankName || this.tankName;
                        this.tankFarm = item.tankFarm || this.tankFarm;
                        this.selectedCustomer = item?.customer?.split(",")?.map(item => item.trim()) || [];
                        this.tankId = item.tankId || null;
                    }

                    const res2 = await getTransactionRecord(this.$route.query.id);
                    if (res2?.code === 200 && res2.data) {
                        this.transactionList = res2.data.rows?.map(row => ({
                            ...row,
                            operationTime: row.operationTime
                                ? dayjs(row.operationTime).format("YYYY-MM-DD HH:mm:ss") ?? ""
                                : "",
                            actionDate: row.actionDate
                                ? dayjs(row.actionDate).format("YYYY-MM-DD HH:mm:ss") ?? ""
                                : "",
                        })) || [];
                        this.total = res2.data.total;
                    }
                    this.getHistoryList();
                }
            } catch (error) {
                console.error("Error fetching tank detail:", error);
                this.$message.error("Error fetching tank detail");
            }
        },

        async getHistoryList() {
            this.timelineloading = true;
            try {
                const params = {
                    tankId: this.tankId,
                    pageNum: this.pageParams.pageNum,
                    pageSize: this.pageParams.pageSize,
                };
                if (this.dateRange && this.dateRange.length === 2) {
                    params.startDate = this.dateRange[0];
                    params.endDate = this.dateRange[1];
                } else {
                    params.startDate = "";
                    params.endDate = "";
                }
                const res = await getTankBookStockHistory(params);
                if (res?.code === 200 && res.data) {

                    const rows = res.data.rows || [];

                    if (rows.length < this.pageParams.pageSize) {
                        this.noLog = true;
                    }

                    this.historyList = rows.map(row => ({
                        id: row.id,
                        tankId: row.tankId,
                        updateBy: row.updateByName,
                        updateByName: row.updateByName,
                        method: row.method,
                        product: row.product,
                        gov: row.gov,
                        gsv: row.gsv,
                        metricTon: row.metricTon,
                        bbl: row.bbl,
                        density: row.density,
                        temp: row.temp,
                        updateTime: dayjs(row.updateTime)
                            .format("YYYY-MM-DD HH:mm:ss"),
                    }));

                    this.historyTotal = res.data.total;
                }

            } catch (error) {
                console.error("Error fetching history list:", error);
                this.$message.error("Error fetching history list");
            } finally {
                this.timelineloading = false;
            }
        },

        async getTransactionList() {
            if (this.dateRange && this.dateRange.length === 2) {
                this.transactionListParams.startDate = this.dateRange[0];
                this.transactionListParams.endDate = this.dateRange[1];
            } else {
                this.transactionListParams.startDate = "";
                this.transactionListParams.endDate = "";
            }

            this.transactionListParams.searchValue = this.searchKeyword || "";

            try {
                const res = await getTransactionRecord(this.$route.query.id, this.transactionListParams);
                if (res?.code === 200 && res.data) {
                    this.transactionList = res.data.rows?.map(row => ({
                        ...row,
                        operationTime: row.operationTime
                            ? dayjs(row.operationTime).format("YYYY-MM-DD HH:mm:ss")
                            : "",
                        actionDate: row.actionDate
                            ? dayjs(row.actionDate).format("YYYY-MM-DD HH:mm:ss") ?? ""
                            : "",
                    })) || [];
                    this.total = res.data.total;
                }
            } catch (error) {
                console.error("Error fetching transaction list:", error);
                this.$message.error("Error fetching transaction list");
            }
        },
        async exportToExcel() {
            try {
                const params = {
                    transactionId: this.$route.query.id,
                    ...this.transactionListParams
                }
                const res = await exportTransactionExcel(params);
                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.download = `TankTransaction_${this.tankName}.xlsx`;
                link.click();
                URL.revokeObjectURL(url);
                this.$message.success("Excel file exported successfully!");
            } catch (error) {
                console.error(error);
                this.$message.error("Failed to export Excel file");
            }
        },
        handleCloseClick() {
            this.pageStatus = 0;
            if (this.$route.query.pageStatus == 2) {
                this.requestData = {};
            }
            this.$router.push({ path: "/tankBookStock/index" });
            setTimeout(() => {
                if (this.$route.path == "/tankBookStock/index" && this.$route.query.id) {
                    this.$router.push({ path: "/tankBookStock/index" });
                }
            }, 500);
        },
        async saveTransaction() {
            try {
                let res;
                if (this.$route.query.id) {
                    res = await modifyTransaction(this.$route.query.id, this.balanceForm);
                } else {
                    res = await createNewTransaction(this.balanceForm);
                }

                if (res.code === 200) {
                    this.$message.success(
                        this.$route.query.id ? "Transaction updated successfully!" : "Transaction created successfully!"
                    );
                    if (!this.$route.query.id) {
                        this.$router.push({
                            path: "/tankBookStock/index",
                            query: {
                                id: res.data,
                                pageStatus: 1,
                            },
                        });
                        sessionStorage.setItem("pageStatus", 1);
                        this.$nextTick(() => {
                            this.getDetail();
                        });
                    } else {
                        this.getDetail();
                        this.getHistoryList();
                    }


                } else {
                    this.$message.error(res.message || "Failed to save transaction");
                }
            } catch (error) {
                console.error(error);
                this.$message.error("Error while saving transaction");
            }
        },
    },
};
</script>


<style lang="scss" scoped>
.timeLine {
    background: #ffffff;
    box-shadow: 0px 4px 4px 1px rgba(196, 196, 196, 0.1);
    border-radius: 2px;
    // height: 452px;
    height: 750px;


    .head {
        font-weight: 700;
        padding: 15px 22px;
        border-bottom: 4px solid #fafafa;
        color: #4c565c;
        font-size: 15px;
    }

    .content {
        padding: 40px 20px;
        // height: calc(432px - 56.5px);
        height: 650px;
        overflow-y: scroll;
    }

    .text {
        color: red;
    }
}

.lastItem ::v-deep .el-timeline-item__tail {
    display: none;
}

.loading .content {
    overflow: hidden;
}

::v-deep .el-timeline-item__node {
    background: $primaryColor;
}

::v-deep .el-timeline-item__tail {
    border-color: $primaryColor;
}

::v-deep .el-timeline-item__content {
    font-size: 14px;

    color: #82889c;
}

.timestamp {
    font-size: 12px;
    color: #82889c;
}

::v-deep .el-divider--horizontal {
    margin: 8px 0;
}

::v-deep .el-divider--horizontal {
    width: 230px;
}

::v-deep .el-timeline {
    height: 315px;
}
</style>